import { AgeCalculator } from "../AgeCalculator";

export class CzechAgeCalculator extends AgeCalculator {
  constructor() {
    super('Europe/Prague');
  }
}
